import React from 'react';
import TemplatesList from './TemplatesList';

const TemplatesView = ({
  templates,
}) => (
  <TemplatesList
    templates={templates}
  />
);

export default TemplatesView;
